// 持仓明细面板
import { Table, Empty, Tag, Space } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useStore } from '../store/account';
import type { Position } from '../../shared/types';
export default function PositionsPanel() {
  const { account } = useStore();
  if (!account) return <Empty description="加载中" />;
  if (account.positions.length === 0) {
    return (
      <div style={{ padding: 24 }}>
        {' '}
        <Empty description="还没有持仓。买入股票后会显示在这里（P2 交易功能即将到来）" />{' '}
      </div>
    );
  }
  const totalProfit = account.positions.reduce((s, p) => s + p.profitAmount, 0);
  const totalProfitPercent =
    account.marketValue > 0 ? (totalProfit / (account.marketValue - totalProfit)) * 100 : 0;
  const columns: ColumnsType<Position> = [
    {
      title: '名称',
      dataIndex: 'name',
      render: (v: string, r) => (
        <Space size={4} direction="vertical" style={{ lineHeight: 1.2 }}>
          {' '}
          <span>{v}</span>{' '}
          <span style={{ fontSize: 11, color: '#8b949e', fontFamily: 'monospace' }}>
            {r.code}
          </span>{' '}
        </Space>
      ),
    },
    {
      title: '持仓',
      dataIndex: 'shares',
      align: 'right',
      render: (v: number) => v.toLocaleString(),
    },
    {
      title: '成本价',
      dataIndex: 'costPrice',
      align: 'right',
      render: (v: number) => v.toFixed(2),
    },
    {
      title: '现价',
      dataIndex: 'currentPrice',
      align: 'right',
      render: (v: number) => v.toFixed(2),
    },
    {
      title: '浮盈',
      dataIndex: 'profitPercent',
      align: 'right',
      render: (v: number, r) => {
        const color = v > 0 ? '#ff4d4f' : v < 0 ? '#52c41a' : '#8b949e';
        return (
          <Space size={4} direction="vertical" style={{ lineHeight: 1.2, textAlign: 'right' }}>
            {' '}
            <span style={{ color, fontWeight: 600 }}>
              {' '}
              {v > 0 ? '+' : ''} {v.toFixed(2)}%{' '}
            </span>{' '}
            <span style={{ color, fontSize: 11 }}>
              {' '}
              {r.profitAmount > 0 ? '+' : ''}{' '}
              {r.profitAmount.toLocaleString(undefined, { maximumFractionDigits: 0 })}{' '}
            </span>{' '}
          </Space>
        );
      },
    },
  ];
  return (
    <div style={{ padding: 16 }}>
      {' '}
      <div
        style={{
          background: '#1c2128',
          border: '1px solid #30363d',
          borderRadius: 8,
          padding: 12,
          marginBottom: 16,
        }}
      >
        {' '}
        <Space size="large">
          {' '}
          <div>
            {' '}
            <div style={{ fontSize: 12, color: '#8b949e' }}>总市值</div>{' '}
            <div style={{ fontSize: 20, fontWeight: 700 }}>
              {' '}
              {account.marketValue.toLocaleString()}{' '}
            </div>{' '}
          </div>{' '}
          <div>
            {' '}
            <div style={{ fontSize: 12, color: '#8b949e' }}>浮动盈亏</div>{' '}
            <div
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: totalProfit > 0 ? '#ff4d4f' : totalProfit < 0 ? '#52c41a' : '#e6edf3',
              }}
            >
              {' '}
              {totalProfit > 0 ? '+' : ''}{' '}
              {totalProfit.toLocaleString(undefined, { maximumFractionDigits: 0 })}{' '}
              <span style={{ fontSize: 12, marginLeft: 6, color: '#8b949e' }}>
                {' '}
                ({totalProfitPercent.toFixed(2)}%){' '}
              </span>{' '}
            </div>{' '}
          </div>{' '}
        </Space>{' '}
      </div>{' '}
      <Table
        rowKey="code"
        size="small"
        columns={columns}
        dataSource={account.positions}
        pagination={false}
        style={{ background: 'transparent' }}
      />{' '}
    </div>
  );
}
